<template>
    <div>
        <template>
            <h2 align="center" class="my-5">¿Que informe necesitas?</h2>
            <div :class="$style.wrapper">
                <button-card
                    v-for="(card, index) in cards"
                    :icon="card.icon"
                    @click="setReportType(card.type)"
                    :type="type === card.type ? 'primary' : 'default'"
                    >{{ card.title }}
                </button-card>
            </div>
        </template>

        <template v-if="step >= 2 && hasFilters">
            <div v-if="type === '347_provider' || type === '347_client'" class="filter-mode">
                <label> <input type="radio" name="filter_mode" v-model="filterMode" value="generate" /> Generar </label>
                <label> <input type="radio" name="filter_mode" v-model="filterMode" value="view" /> Visualizar </label>
            </div>

            <h2 v-if="type === '347_provider' || type === '347_client'" align="center" class="my-2">
                Especifica los filtros
            </h2>
            <!-- Refactor start by @FelipeGCx-->
            <div v-if="type === '347_provider' || type === '347_client'" class="filters-reports">
                <div v-if="filterMode === 'generate'" class="generate">
                    <div v-if="isProviderVisible">
                        <h6 :class="$style.title"><fa-icon size="2x" :icon="['fal', 'users']" /> Proveedores</h6>
                        <g-field
                            class="provider-picker"
                            name="providers"
                            :placeholder="providersPlaceholder"
                            type="relation"
                            table="providers"
                            v-model="providers"
                            ret-label="name"
                            :multiple="type != '347_provider' ? true : false"
                        />
                    </div>
                    <div v-if="isClientVisible">
                        <h6 :class="$style.title">
                            <fa-icon size="2x" class="mb-1" :icon="['fal', 'users']" /> Clientes
                        </h6>
                        <g-field
                            class="client-picker"
                            name="clients"
                            :placeholder="clientsPlaceholder"
                            type="relation"
                            table="clients"
                            v-model="clients"
                            ret-label="alias"
                            :multiple="type != '347_client' ? true : false"
                        />
                    </div>
                    <a-range-picker
                        v-if="isYearVisible"
                        v-model="date"
                        :placeholder="['Desde', 'Hasta']"
                        :ranges="clientAndProviderRanges"
                        :disabled-date="disabledDate"
                    />
                </div>
                <div v-else class="view">
                    <div v-if="isProviderVisible">
                        <h6 :class="$style.title"><fa-icon size="2x" :icon="['fal', 'users']" /> Proveedores</h6>
                        <g-field
                            class="provider-picker"
                            name="providers"
                            :placeholder="providersPlaceholder"
                            type="relation"
                            table="providers"
                            v-model="providers"
                            ret-label="name"
                            :multiple="type != '347_provider' ? true : false"
                        />
                    </div>
                    <div v-if="isClientVisible">
                        <h6 :class="$style.title">
                            <fa-icon size="2x" class="mb-1" :icon="['fal', 'users']" /> Clientes
                        </h6>
                        <g-field
                            class="client-picker"
                            name="clients"
                            :placeholder="clientsPlaceholder"
                            type="relation"
                            table="clients"
                            v-model="clients"
                            ret-label="alias"
                            :multiple="type != '347_client' ? true : false"
                        />
                    </div>
                    <a-range-picker
                        v-if="isYearVisible"
                        v-model="date"
                        :placeholder="['Desde', 'Hasta']"
                        :ranges="clientAndProviderRanges"
                        :disabled-date="disabledDate"
                    />
                    <!-- <div v-if="isYearVisible">
                        <h6 :class="$style.title"><fa-icon size="2x" :icon="['fal', 'calendar']" /> Año</h6>
                        <ul>
                            <li v-for="(item, index) in years">
                                <a-button
                                    size="large"
                                    :type="year == item ? 'primary' : 'default'"
                                    :key="index"
                                    @click="year = item"
                                    >{{ item }}</a-button
                                >
                            </li>
                        </ul>
                    </div>
                    <div v-if="isMonthVisible">
                        <h6 :class="$style.title"><fa-icon size="2x" :icon="['fal', 'calendar']" /> Mes</h6>
                        <ul>
                            <li v-for="(item, index) in filteredMonths">
                                <a-button
                                    size="large"
                                    :type="month == item ? 'primary' : 'default'"
                                    :key="index"
                                    @click="month = item"
                                    >{{ filteredMonths[index] }}</a-button
                                >
                            </li>
                        </ul>
                    </div> -->
                </div>
            </div>
            <!-- Refactor end -->

            <h2 v-if="type !== '347_provider' && type !== '347_client'" align="center" class="my-5">
                Especifica los filtros
            </h2>

            <div v-if="type !== '347_provider' && type !== '347_client'" class="row">
                <div class="col-12 text-center mb-4" v-if="isDateRangeVisible">
                    <h6 :class="$style.title" class="mb-2">
                        <fa-icon size="2x" class="mb-1" :icon="['fal', 'calendar']" /> <br />Fechas
                    </h6>

                    <a-range-picker
                        v-model="date"
                        :placeholder="['Desde', 'Hasta']"
                        :ranges="ranges"
                        :disabled-date="disabledDate"
                    />
                </div>

                <div class="col-12 text-center" v-if="isClientVisible">
                    <h6 :class="$style.title" class="mb-2">
                        <fa-icon size="2x" class="mb-1" :icon="['fal', 'users']" /> <br />Clientes
                    </h6>

                    <div style="max-width: 680px; margin: 0 auto">
                        <g-field
                            name="clients"
                            :placeholder="clientsPlaceholder"
                            type="relation"
                            table="clients"
                            v-model="clients"
                            ret-label="alias"
                            :multiple="type != '347_client' ? true : false"
                        />
                    </div>
                </div>

                <div class="col-12 text-center" v-if="isProviderVisible">
                    <h6 :class="$style.title" class="mb-2">
                        <fa-icon size="2x" class="mb-1" :icon="['fal', 'users']" /> <br />Proveedores
                    </h6>

                    <div style="max-width: 680px; margin: 0 auto">
                        <g-field
                            name="providers"
                            :placeholder="providersPlaceholder"
                            type="relation"
                            table="providers"
                            v-model="providers"
                            ret-label="name"
                            :multiple="type != '347_provider' ? true : false"
                        />
                    </div>
                </div>

                <div class="col-12 text-center mb-4" v-if="isYearVisible">
                    <h6 :class="$style.title" class="mb-3">
                        <fa-icon size="2x" class="mb-1" :icon="['fal', 'calendar']" /> <br />Año
                    </h6>

                    <div style="max-width: 680px; margin: 0 auto">
                        <a-button
                            class="mr-2"
                            size="large"
                            :type="year == item ? 'primary' : 'default'"
                            v-for="(item, index) in years"
                            :key="index"
                            @click="year = item"
                            >{{ item }}</a-button
                        >
                    </div>
                </div>

                <div class="col-12 text-center mb-4" v-if="isMonthVisible">
                    <h6 :class="$style.title" class="mb-3">
                        <fa-icon size="2x" class="mb-1" :icon="['fal', 'calendar']" /> <br />Mes
                    </h6>

                    <div style="max-width: 680px; margin: 0 auto">
                        <a-button
                            class="mr-2"
                            size="large"
                            :type="month == item ? 'primary' : 'default'"
                            v-for="(item, index) in filteredMonths"
                            :key="index"
                            @click="month = item"
                            >{{ filteredMonths[index] }}</a-button
                        >
                    </div>
                </div>
            </div>
        </template>

        <template v-if="step >= 3">
            <h2 v-if="type === '347_provider' || type === '347_client'" align="center" class="my-2">
                Selecciona el formato de salida
            </h2>

            <!-- Refactor start by @FelipeGCx-->
            <div v-if="type === '347_provider' || type === '347_client'" class="action-reports">
                <div v-if="filterMode === 'generate'" class="generate">
                    <div class="export-type">
                        <button-card
                            :icon="['fal', 'file-pdf']"
                            @click="setFormatType('pdf')"
                            :type="format === 'pdf' ? 'primary' : 'default'"
                            >PDF</button-card
                        >
                        <button-card
                            :icon="['fal', 'file-excel']"
                            @click="setFormatType('xlsx')"
                            :type="format === 'xlsx' ? 'primary' : 'default'"
                            >EXCEL</button-card
                        >
                    </div>
                    <a-button
                        v-if="format"
                        @click="download"
                        :loading="downloading"
                        type="primary"
                        size="large"
                        class="text-uppercase"
                    >
                        <h6 class="text-white d-inline-block">Descargar</h6>
                    </a-button>
                </div>
                <div v-else class="view">
                    <button-card
                        v-if="isGestiosReport"
                        class="mb-0"
                        :icon="['fal', 'file-lines']"
                        @click="showReport"
                        type="primary"
                        >Ver en Gestios</button-card
                    >
                </div>
            </div>
            <!-- Refactor end -->

            <h2 v-if="type !== '347_provider' && type !== '347_client'" align="center" class="my-5">
                Selecciona el formato de salida
            </h2>

            <div v-if="type !== '347_provider' && type !== '347_client'" class="row justify-content-center">
                <div class="col-12 col-sm-6 col-md-6 col-lg-2" v-if="isPDFReport">
                    <button-card
                        :icon="['fal', 'file-pdf']"
                        @click="setFormatType('pdf')"
                        :type="format === 'pdf' ? 'primary' : 'default'"
                        >PDF</button-card
                    >
                </div>

                <div class="col-12 col-sm-6 col-md-6 col-lg-2" v-if="isExcelReport">
                    <button-card
                        :icon="['fal', 'file-excel']"
                        @click="setFormatType('xlsx')"
                        :type="format === 'xlsx' ? 'primary' : 'default'"
                        >EXCEL</button-card
                    >
                </div>

                <div class="col-12 col-sm-6 col-md-6 col-lg-2" v-if="isGestiosReport">
                    <button-card :icon="['fal', 'file-lines']" @click="showReport" type="primary"
                        >Ver en Gestios</button-card
                    >
                </div>
            </div>

            <div class="text-center" v-if="format && type !== '347_provider' && type !== '347_client'">
                <a-button @click="download" :loading="downloading" type="primary" size="large" class="text-uppercase">
                    <h6 class="mb-0 text-white d-inline-block">Descargar</h6>
                </a-button>
            </div>
        </template>

        <a-modal
            v-if="type === '347_provider'"
            v-model="modalProviderVisible"
            title="Gastos por proveedor"
            width="700px"
            :footer="null"
            destroyOnClose
        >
            <provider-table :provider="providers.key" :date="reportDate" />
        </a-modal>
        <a-modal
            v-else-if="type === '347_client'"
            v-model="modalClientVisible"
            title="Ingresos por cliente"
            width="700px"
            :footer="null"
            destroyOnClose
        >
            <client-table :client="clients.key" :date="reportDate" />
        </a-modal>
    </div>
</template>

<script>
import moment from 'moment'
import files from '@/application/lib/files'
import ProviderTable from './provider-table.vue'
import ClientTable from './client-table.vue'

const currentYear = moment().year()
const currentMonth = moment().month() + 1

export default {
    name: 'Reports',
    components: { ProviderTable, ClientTable },
    data: () => ({
        type: '',
        types: [
            'clients',
            'providers',
            'expenses',
            'invoices',
            'invoices_client',
            'articles',
            'articles_client',
            '347_provider',
            '347_client',
        ],
        date: [],
        year: moment().format('YYYY'),
        years: [moment().subtract(1, 'year').format('YYYY'), moment().format('YYYY')],
        months: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
        ],
        month: '',
        clients: [],
        providers: [],
        format: '',
        downloading: false,
        modalProviderVisible: false,
        modalClientVisible: false,
        reportDate: '',
        filterMode: 'generate',
        cards: [
            {
                icon: ['fal', 'users'],
                type: 'clients',
                title: 'Clientes',
            },
            {
                icon: ['fal', 'users-crown'],
                type: 'providers',
                title: 'Proveedores',
            },
            {
                icon: ['fal', 'receipt'],
                type: 'expenses',
                title: 'Gastos',
            },
            {
                icon: ['fal', 'file-invoice'],
                type: 'invoices',
                title: 'Facturas',
            },
            {
                icon: ['fal', 'file-invoice'],
                type: 'invoices_client',
                title: 'Facturas por cliente',
            },
            {
                icon: ['fal', 'box'],
                type: 'articles',
                title: 'Artículos',
            },
            {
                icon: ['fal', 'rectangle-history-circle-user'],
                type: 'articles_client',
                title: 'Artículos por cliente',
            },
            {
                icon: ['fal', 'book'],
                type: '347_provider',
                title: 'Gastos por proveedor',
            },
            {
                icon: ['fal', 'book'],
                type: '347_client',
                title: 'Ingresos por cliente',
            },
        ],
    }),
    mounted() {
        this.month = this.months[moment().month()]
    },
    computed: {
        step() {
            if (!this.type) return 1
            if (this.isDateRangeVisible && this.date.length < 2) return 2
            return 3
        },
        isDateRangeVisible() {
            if (['clients', 'providers', '347_provider', '347_client'].includes(this.type)) {
                return false
            }

            return true
        },
        isClientVisible() {
            if (['invoices_client', 'articles_client', '347_client'].includes(this.type)) {
                return true
            }

            return false
        },
        isProviderVisible() {
            if (['invoices_client', 'articles_client', '347_provider'].includes(this.type)) {
                return true
            }

            return false
        },
        isYearVisible() {
            if (['347_client', '347_provider'].includes(this.type)) {
                return true
            }

            return false
        },
        isMonthVisible() {
            if (['347_client', '347_provider'].includes(this.type)) {
                return true
            }

            return false
        },
        isPDFReport() {
            return !['347_client', '347_provider'].includes(this.type)
        },
        isGestiosReport() {
            return ['347_client', '347_provider'].includes(this.type)
        },
        isExcelReport() {
            if (['347_client', '347_provider'].includes(this.type)) {
                return false
            }

            return true
        },
        hasFilters() {
            return this.isDateRangeVisible || this.isClientVisible || this.isYearVisible || this.isMonthVisible
        },
        filename() {
            let name = ''
            if (this.type === 'clients') {
                name = 'Informe Clientes'
            } else if (this.type === 'providers') {
                name = 'Informe Proveedores'
            } else if (this.type === 'expenses') {
                name = 'Informe Gastos'
            } else if (this.type === 'invoices') {
                name = 'Informe Facturas'
            } else if (this.type === 'invoices_client') {
                name = 'Informe Facturas Cliente'
            } else if (this.type === 'articles') {
                name = 'Informe Artículos'
            } else if (this.type === 'articles_client') {
                name = 'Informe Articulos Cliente'
            } else if (this.type === '347_provider') {
                name = 'Informe Gastos Proveedor'
            } else if (this.type === '347_client') {
                name = 'Informe Gastos Cliente'
            } else {
                name = 'Desconocido'
            }

            if (['pdf', 'xlsx'].includes(this.format)) {
                name += '.' + this.format
            } else {
                name += '.txt'
            }

            return name
        },
        ranges() {
            return {
                'Este mes': [this.$moment().startOf('month'), this.$moment()],
                'Este año': [this.$moment().startOf('year'), this.$moment()],
            }
        },
        clientAndProviderRanges() {
            return this.years.reduce((acc, year) => {
                if (year == currentYear) {
                    acc[year] = [this.$moment(year).startOf('year'), this.$moment()]
                } else {
                    acc[year] = [this.$moment(year).startOf('year'), this.$moment(year).endOf('year')]
                }
                return acc
            }, {})
        },
        filteredMonths() {
            return currentYear != this.year ? this.months : this.months.slice(0, currentMonth)
        },
        providersPlaceholder() {
            return this.type === '347_provider' ? 'Selecciona un proveedor' : 'Selecciona uno o mas proveedores'
        },
        clientsPlaceholder() {
            return this.type === '347_client' ? 'Selecciona un cliente' : 'Selecciona uno o mas clientes'
        },
    },
    methods: {
        // Disable future days
        disabledDate(current) {
            return current && current > this.$moment().endOf('day')
        },
        // Set the report type
        setReportType(type) {
            if (this.types.includes(type)) {
                this.type = type
            }
        },
        // Set format
        setFormatType(format) {
            if (['pdf', 'xlsx'].includes(format)) {
                this.format = format
            }
        },
        // Download report
        async download() {
            this.downloading = true

            try {
                let params = {}

                if (this.isDateRangeVisible && this.date.length === 2) {
                    params.from = this.date[0].format('YYYY-MM-DD')
                    params.to = this.date[1].format('YYYY-MM-DD')
                }

                if (this.isYearVisible) {
                    params.from = this.date[0].format('YYYY-MM-DD')
                    params.to = this.date[1].format('YYYY-MM-DD')
                }

                if (this.isClientVisible && this.clients.length > 0) {
                    params.clients = this.clients.map((c) => c.key).join(',')
                } else if (this.isClientVisible && this.clients.key != '') {
                    params.clients = this.clients.key
                }

                if (this.isProviderVisible && this.providers.length > 0) {
                    params.providers = this.providers.map((c) => c.key).join(',')
                } else if (this.isProviderVisible && this.providers.key != '') {
                    params.providers = this.providers.key
                }

                const res = await this.$lambda.get(`/reports/${this.type}/${this.format}`, {
                    responseType: 'blob',
                    params: params,
                })

                if (res.ok) {
                    files.download(res.data, this.filename)
                    this.$message.success('Informe generado. Descargando fichero...')
                } else {
                    throw new Error(res.message)
                }
            } catch (err) {
                this.$message.error(err.message)
            } finally {
                this.downloading = false
            }
        },

        showReport() {
            // let monthFormatted = this.months.findIndex((month) => this.month === month) + 1
            // if (monthFormatted < 10) monthFormatted = '0' + monthFormatted
            // this.reportDate = `${this.year}-${monthFormatted}-01`

            this.reportDate = this.date
            if (this.type === '347_provider') {
                if (this.providers.key != '') this.showProviderModal()
                else this.$message.error('Debes escoger un proveedor')
            } else if (this.type === '347_client') {
                if (this.clients.key != '') this.showClientModal()
                else this.$message.error('Debes escoger un cliente')
            }
        },
        showProviderModal() {
            this.modalProviderVisible = true
        },
        showClientModal() {
            this.modalClientVisible = true
        },
    },
}
</script>

<style lang="scss" module>
.title {
    text-transform: uppercase;
    font-size: 14px;
    color: var(--primary);
    margin-bottom: 0;
}

.typeSelected {
    background: var(--primary);

    .icon {
        color: #fff;
    }

    .title {
        color: #fff;
    }
}

.wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
    gap: 1rem;
    margin-bottom: 2rem;

    & > div {
        margin-bottom: 0;
        &:hover {
            transform: scale(1.05);
        }
    }
}
</style>

<style lang="scss">
.filter-mode {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 400;
        padding: 0.6rem 1rem;
        margin-bottom: 0;
        background-color: $gray-3;
        color: $dark-gray-6;
        cursor: pointer;
        min-width: 10rem;
        text-align: center;

        &:has(input:checked) {
            background-color: $primary;
            color: white;
        }
        &:hover {
            background-color: $primary;
            color: white;
            opacity: 0.5;
        }

        input {
            opacity: 0;
            position: absolute;
        }
    }
    & > :last-child {
        border-top-right-radius: 0.4rem;
        border-bottom-right-radius: 0.4rem;
    }
    & > :first-child {
        border-top-left-radius: 0.4rem;
        border-bottom-left-radius: 0.4rem;
    }
}
.filters-reports {
    width: 50%;
    margin: 0 auto;
    height: fit-content;

    .generate,
    .view {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 2rem;
        height: 100%;
        gap: 1rem;

        & > * {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 1rem;
            width: 100%;
            h6 {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 0.2rem;
            }
            ul {
                list-style: none;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;
                gap: 0.6rem;
                margin: 0;
                padding: 0;
            }
            .provider-picker,
            .client-picker {
                width: 100%;

                div {
                    margin-bottom: 0 !important;
                }
            }
        }
    }
}
.action-reports {
    width: 50%;
    margin: 0 auto;
    height: fit-content;

    .generate,
    .view {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        border-radius: 0.5rem;
        padding: 2rem;
        height: 100%;
        gap: 1rem;
        .export-type {
            width: 100%;
            display: flex;
            gap: 1rem;
            & > * {
                flex: 1;
                margin-bottom: 0;
            }
        }
    }
}
</style>
